import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M10.948 1.357h-4.26a2.28 2.28 0 0 0-2.26 2 2.28 2.28 0 0 0-2 2.26v6.51a2.294 2.294 0 0 0 2.29 2.28h5.05a2.288 2.288 0 0 0 2.26-2 2.28 2.28 0 0 0 2-2.26V4.3Zm-1.18 11.55h-5.05a.79.79 0 0 1-.79-.78v-6.51a.776.776 0 0 1 .48-.71v5.24a2.279 2.279 0 0 0 2.28 2.28h3.8a.79.79 0 0 1-.72.48Zm2.76-2.76a.781.781 0 0 1-.78.78h-5.06a.781.781 0 0 1-.78-.78v-6.5a.783.783 0 0 1 .78-.79h3.75v1.96h2.09Z';
const draw24px =
  'M20,7.41,15.51,2.92V2.75H9.35a3.1,3.1,0,0,0-3.1,3,3.1,3.1,0,0,0-3,3.09v10A3.1,3.1,0,0,0,6.32,21.9h7.73a3.1,3.1,0,0,0,3.1-3,3.1,3.1,0,0,0,3-3.09V7.41Zm-5.95,13H6.32a1.59,1.59,0,0,1-1.59-1.59V8.86A1.59,1.59,0,0,1,6.25,7.28v8.51a3.1,3.1,0,0,0,3.1,3.09h6.29A1.58,1.58,0,0,1,14.05,20.4Zm4.62-4.61a1.59,1.59,0,0,1-1.59,1.59H9.35a1.6,1.6,0,0,1-1.6-1.59V5.84a1.6,1.6,0,0,1,1.6-1.59h5.38V8.19h3.94Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const DocumentTwoIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'documentTwo'),
) as IconWithRender;

DocumentTwoIcon.displayName = 'DocumentTwoIcon';
DocumentTwoIcon.propTypes = Icon.propTypes;
DocumentTwoIcon.renderIcon = (props) => <DocumentTwoIcon {...props} />;
export default DocumentTwoIcon;
